import { z } from 'zod'

import type { AnalyticsQueryFilter } from '@hap/analytics'

import {
  FilterOpIn,
  convertToAnalyticsFilters,
  dashboardFilters,
} from '../../-components/filter-utils'

export const activityFilters = dashboardFilters.extend({
  handledByIds: FilterOpIn.optional(),
})
export type ActivityFilters = z.infer<typeof activityFilters>

const filterFields: Record<keyof ActivityFilters, string> = {
  channelIds: 'channelId',
  tagIds: 'tagIds',
  groupIds: 'groupIds',
  reportsToIds: 'assignedSupervisorId',
  intentIds: 'intentId',
  handleTime: 'handleTime',
  handledByIds: 'handledByIds',
}

export function convertActivityFilters(filters: ActivityFilters): AnalyticsQueryFilter[] {
  const result = convertToAnalyticsFilters(filters)
  if (filters.handledByIds?.values.length) {
    result.push({ field: 'handledByIds', ...filters.handledByIds })
  }
  return result
}

export function resetActivityFilters(
  filters: ActivityFilters,
  isFilterAllowed: (field: string) => boolean,
): ActivityFilters {
  return Object.fromEntries(
    Object.entries(filters).filter(
      ([key]) => !isFilterAllowed(filterFields[key as keyof ActivityFilters]),
    ),
  )
}
